import { IStateType } from '@/store/types'
import { getCurrentInstance } from 'vue'
import type { Store as VuexStore } from 'vuex'

export const useStore = () => {
  const vm = getCurrentInstance()
  if (!vm) throw new Error('must be called in setup')
  return vm.proxy.$store as VuexStore<IStateType>
}
